import { BaseService } from "./common/base";

export class ContactService extends BaseService<unknown> {
  constructor() {
    super("contacts");
  }

  find(
    { userType, id }: { userType: string; id: string },
    params: Record<string, any> = {}
  ) {
    return this._get(`/${userType}/${id}`, { params });
  }

  inviteExisting(
    { userType, id }: { userType: string; id: string },
    { userId, message }
  ) {
    return this._post(`/${userType}/${id}/invite-existing`, {
      userId,
      message,
    });
  }

  inviteNew(
    { userType, id }: { userType: string; id: string },
    { email, message }
  ) {
    return this._post(`/${userType}/${id}/invite-new`, {
      email,
      message,
    });
  }

  request({ userType, id }: { userType: string; id: string }) {
    return this._post(`/${userType}/${id}/request`);
  }
}
